import React, { useState, useEffect } from 'react';
import './FormAnalytics.css';

const FormAnalytics = ({ templates, onClose }) => {
    const [analytics, setAnalytics] = useState({
        totalTemplates: 0,
        totalSubmissions: 0,
        activeTemplates: 0,
        averageFields: 0,
        submissionsByMonth: [],
        popularFieldTypes: [],
        topPerformingForms: []
    });

    useEffect(() => {
        // Calculate analytics from templates
        const totalTemplates = templates.length;
        const activeTemplates = templates.filter(t => t.is_published).length;
        const totalFields = templates.reduce((sum, t) => sum + (t.fields?.length || 0), 0);
        const averageFields = totalTemplates > 0 ? Math.round(totalFields / totalTemplates) : 0;
        
        // Mock data for demonstration
        const mockAnalytics = {
            totalTemplates,
            totalSubmissions: Math.floor(Math.random() * 500) + 200,
            activeTemplates,
            averageFields,
            submissionsByMonth: [
                { month: 'Jan', submissions: 45 },
                { month: 'Feb', submissions: 52 },
                { month: 'Mar', submissions: 38 },
                { month: 'Apr', submissions: 61 },
                { month: 'May', submissions: 55 },
                { month: 'Jun', submissions: 67 },
                { month: 'Jul', submissions: 73 },
                { month: 'Aug', submissions: 89 }
            ],
            popularFieldTypes: [
                { type: 'Text Input', count: 24, percentage: 35 },
                { type: 'Select', count: 18, percentage: 26 },
                { type: 'Rating', count: 12, percentage: 18 },
                { type: 'Textarea', count: 8, percentage: 12 },
                { type: 'Checkbox', count: 6, percentage: 9 }
            ],
            topPerformingForms: templates.slice(0, 5).map(t => ({
                name: t.title,
                submissions: Math.floor(Math.random() * 100) + 20,
                completionRate: Math.floor(Math.random() * 30) + 70
            }))
        };
        
        setAnalytics(mockAnalytics);
    }, [templates]);

    return (
        <div className="analytics-overlay">
            <div className="analytics-container">
                <div className="analytics-header">
                    <h2>Form Analytics Dashboard</h2>
                    <button onClick={onClose} className="analytics-close-btn">✕</button>
                </div>

                <div className="analytics-content">
                    {/* Key Metrics */}
                    <div className="metrics-grid">
                        <div className="metric-card">
                            <div className="metric-icon">📋</div>
                            <div className="metric-content">
                                <h3>{analytics.totalTemplates}</h3>
                                <p>Total Templates</p>
                            </div>
                        </div>
                        <div className="metric-card">
                            <div className="metric-icon">📊</div>
                            <div className="metric-content">
                                <h3>{analytics.totalSubmissions}</h3>
                                <p>Total Submissions</p>
                            </div>
                        </div>
                        <div className="metric-card">
                            <div className="metric-icon">✅</div>
                            <div className="metric-content">
                                <h3>{analytics.activeTemplates}</h3>
                                <p>Active Templates</p>
                            </div>
                        </div>
                        <div className="metric-card">
                            <div className="metric-icon">🎯</div>
                            <div className="metric-content">
                                <h3>{analytics.averageFields}</h3>
                                <p>Avg. Fields per Form</p>
                            </div>
                        </div>
                    </div>

                    {/* Charts and Data */}
                    <div className="analytics-charts">
                        <div className="chart-section">
                            <h3>Submissions by Month</h3>
                            <div className="bar-chart">
                                {analytics.submissionsByMonth.map((data, index) => (
                                    <div key={index} className="bar-item">
                                        <div 
                                            className="bar" 
                                            style={{ height: `${(data.submissions / 100) * 100}%` }}
                                        ></div>
                                        <span className="bar-label">{data.month}</span>
                                        <span className="bar-value">{data.submissions}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="chart-section">
                            <h3>Popular Field Types</h3>
                            <div className="pie-chart-data">
                                {analytics.popularFieldTypes.map((field, index) => (
                                    <div key={index} className="pie-item">
                                        <div className="pie-color" style={{ backgroundColor: `hsl(${index * 60}, 70%, 60%)` }}></div>
                                        <span className="pie-label">{field.type}</span>
                                        <span className="pie-value">{field.count} ({field.percentage}%)</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="chart-section">
                            <h3>Top Performing Forms</h3>
                            <div className="performance-list">
                                {analytics.topPerformingForms.map((form, index) => (
                                    <div key={index} className="performance-item">
                                        <div className="performance-info">
                                            <strong>{form.name}</strong>
                                            <span>{form.submissions} submissions</span>
                                        </div>
                                        <div className="performance-rate">
                                            <div className="rate-bar">
                                                <div 
                                                    className="rate-fill" 
                                                    style={{ width: `${form.completionRate}%` }}
                                                ></div>
                                            </div>
                                            <span>{form.completionRate}%</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormAnalytics;
